<template>
    <div class="radio-group">
        <div v-for="item in aData" :key="item.value" :class="item.value === curValue ? 'radio active' : 'radio'">
            <input type="radio" :name="name" :value="item.value" :checked="item.value === curValue" @click="changeCurVal(item)">
            <label class="radio-label" v-text="item.text"></label>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            aData: [],
            curValue: null
        }
    },
    props: {
        name: {
            type: String
        },
        defaultValue: {
          type: String,
          default: "",
        },
        data: {
            type: Array,
            default: () => {
                return []
            }
        },
        change: {
            type: Function
        }
    },
    created () {
        this.aData = this.data
        this.curValue = this.defaultValue
    },
    methods: {
        changeCurVal (item) {
          if (item.value === this.curValue) {
            return
          }
          this.curValue = item.value
          this.$emit('change', item.value)
          this.change(item.value)
        }
    }
}
</script>
